/**
 * CheckmarkIcon/index.js
 * desc: checkmark icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const CheckmarkIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="checkmark icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.checkmark.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg"><path d="M6 11.17L1.83 7 .41 8.41 6 14 18 2 16.59.59 6 11.17z"/></svg>
    </IconButton>
);


export default CheckmarkIcon;
